module.exports = fox._r("images/dislike.png", __webpack_public_path__ + "images/dislike.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/dislike.png
// module id = 1038
// module chunks = 4